import { render, staticRenderFns } from "./header-cart.vue?vue&type=template&id=2722a230&scoped=true&"
import script from "./header-cart.vue?vue&type=script&lang=js&"
export * from "./header-cart.vue?vue&type=script&lang=js&"
import style0 from "./header-cart.vue?vue&type=style&index=0&id=2722a230&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2722a230",
  null
  
)

export default component.exports